import { render, staticRenderFns } from "./VehicleParkingSituation.vue?vue&type=template&id=2fef456e&scoped=true&"
import script from "./VehicleParkingSituation.vue?vue&type=script&lang=js&"
export * from "./VehicleParkingSituation.vue?vue&type=script&lang=js&"
import style0 from "./VehicleParkingSituation.vue?vue&type=style&index=0&id=2fef456e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef456e",
  null
  
)

export default component.exports